import { render, staticRenderFns } from "./CompanyParentsView.vue?vue&type=template&id=147d67fd&scoped=true"
import script from "./CompanyParentsView.vue?vue&type=script&lang=js"
export * from "./CompanyParentsView.vue?vue&type=script&lang=js"
import style0 from "./CompanyParentsView.vue?vue&type=style&index=0&id=147d67fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d67fd",
  null
  
)

export default component.exports